const dispatch = require("~/store.js").dispatch;

const events = require("./routeChangeEvents.js");

const routeChangeDispatchers = {
    ChangedToSurveyList(searchParams) {
        const changed = events.ChangedToSurveyList.New(searchParams);

        dispatch(changed);
    },
    ChangedToSurvey(surveyType, facNumber, surveyID, pageID, sectionID) {
        const changed =
            events.ChangedToSurvey.New(surveyType, facNumber, surveyID, pageID, sectionID);

        dispatch(changed);
    },
    ChangedToSurveyConfirmation(surveyType, facNumber, surveyID) {
        const changed = 
            events.ChangedToSurveyConfirmation.New(surveyType, facNumber, surveyID); 

        dispatch(changed); 
    }, 
    ChangedToSurveySummary(surveyType, facNumber, surveyID) {
        const changed =
            events.ChangedToSurveySummary.New(surveyType, facNumber, surveyID);

        dispatch(changed);
    },
    ChangedToLegacySurvey(surveyType, facNumber, surveyID) {
        const changed =
            events.ChangedToLegacySurvey.New(surveyType, facNumber, surveyID);

        dispatch(changed);
    },
    ChangedToSurveyNotFound(surveyType, surveyID) {
        const changed =
            events.ChangedToSurveyNotFound.New(surveyType, surveyID);

        dispatch(changed);
    },
    ChangedToImpersonation() {
        const changed = events.ChangedToImpersonation.New();

        dispatch(changed);
    },
    ChangedToReports() {
        const changed = events.ChangedToReports.New();

        dispatch(changed);
    },
    ChangedToWalkThru(surveyType, facNumber, surveyID) {
        const changed = events.ChangedToWalkThru.New(surveyType, facNumber, surveyID);

        dispatch(changed);
    }
};

module.exports = routeChangeDispatchers;


// WEBPACK FOOTER //
// ./src/events/routeChange/routeChangeDispatchers.js